import React, { useMemo } from 'react';

// Builds a seamless tiling wave path across `width`, repeating every `period`.
const buildWave = (period, amp, y0, width = 2880) => {
  let d = `M0 ${y0}`;
  let x = 0;
  let dir = -1;
  const half = period / 2;
  while (x < width) {
    const cx = x + half / 2;
    const nx = x + half;
    d += ` Q ${cx} ${y0 + dir * amp} ${nx} ${y0}`;
    x = nx;
    dir *= -1;
  }
  return d;
};

/**
 * Subtle animated "audio frequency" wave background.
 * Very low opacity, drifts horizontally — evokes sound waves / audition.
 */
export const SoundWaveBg = ({ primary = '#1B2A4A', accent = '#C9A24B', className = '' }) => {
  const waves = useMemo(() => ([
    { d: buildWave(360, 46, 200), stroke: primary, w: 2, op: 0.5, dur: 26, delay: 0 },
    { d: buildWave(480, 64, 320), stroke: primary, w: 1.5, op: 0.35, dur: 34, delay: -6 },
    { d: buildWave(288, 34, 430), stroke: accent, w: 1.5, op: 0.45, dur: 22, delay: -3 },
    { d: buildWave(600, 80, 520), stroke: primary, w: 1, op: 0.25, dur: 40, delay: -10 },
  ]), [primary, accent]);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true" style={{ opacity: 0.06 }}>
      <svg className="sw-drift absolute left-0 top-0 h-full" style={{ width: '200%' }} viewBox="0 0 2880 720" preserveAspectRatio="none">
        {waves.map((w, i) => (
          <path key={i} d={w.d} fill="none" stroke={w.stroke} strokeWidth={w.w}
            style={{ opacity: w.op, animation: `swPulse ${w.dur}s ease-in-out ${w.delay}s infinite` }} />
        ))}
      </svg>
      <style>{`
        @keyframes swDrift { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .sw-drift { animation: swDrift 30s linear infinite; }
        @keyframes swPulse { 0%,100% { transform: translateY(0) scaleY(1); } 50% { transform: translateY(-6px) scaleY(1.08); } }
      `}</style>
    </div>
  );
};

export default SoundWaveBg;
